import React, { forwardRef, useMemo } from "react";
import "./PortfolioItem.css";
import { applyGlitchEffect } from "./glitchText";

function truncate(text, max = 230) {
  const t = String(text || "");
  if (t.length <= max) return t;
  const cut = t.slice(0, max);
  const lastSpace = cut.lastIndexOf(" ");
  return (lastSpace > 80 ? cut.slice(0, lastSpace) : cut) + "…";
}

const PortfolioItem = forwardRef(function PortfolioItem({ item, onOpen, highlighted }, ref) {
  const desc = useMemo(() => truncate(item.description, 240), [item.description]);

  return (
    <div
      ref={ref}
      className={["pCard", highlighted ? "is-highlighted" : ""].join(" ")}
      onClick={onOpen}
      role="button"
      tabIndex={0}
      onKeyDown={(e) => e.key === "Enter" && onOpen()}
    >
      <div className="pCard__logo">
        <img
          src={`${process.env.PUBLIC_URL}/${item.imageUrl}`}
          alt={`${item.company_name} logo`}
          onError={(e) => (e.currentTarget.style.opacity = "0.2")}
        />
      </div>

      <div className="pCard__body">
        <div className="pCard__company">{item.company_name}</div>
        <div className="pCard__role">{applyGlitchEffect(item.title)}</div>
        <div className="pCard__desc">{applyGlitchEffect(desc)}</div>

        <div className="pCard__tags">
          {(item.tech_stack || []).slice(0, 6).map((t) => (
            <span key={t} className="pTag">
              {t}
            </span>
          ))}
        </div>
      </div>

      <div className="pCard__foot">
        <div className="pCard__date">{item.date}</div>
        <div className="pCard__open">Open ↗</div>
      </div>
    </div>
  );
});

export default PortfolioItem;
